<div class="d-b m-t-20">
  <label nz-checkbox nzValue="true" [(ngModel)]="hasPoliceStnDetails">Add FIR/Police Station Details</label>
</div>
<form *ngIf="hasPoliceStnDetails" [formGroup]="policeDetailsForm" class="d-b m-t-20">
  <div class="heading-tab">
    <h3 class="heading"><i nz-icon nzType="alert" nzTheme="outline"></i> Police Station Details</h3>
  </div>

  <div class="tab-grid m-t-20">
    <nz-form-item>
      <nz-form-label [nzSpan]="24">FIR Number</nz-form-label>
      <nz-form-control [nzSpan]="24">
        <input nz-input formControlName="FIRNumber" value="MUM67/DDR/334/2019"/>
        <nz-form-explain
        *ngIf="(policeDetailsForm.get('FIRNumber').dirty || policeDetailsForm.get('FIRNumber').touched) && policeDetailsForm.get('FIRNumber').errors">
        <p style="color:red"
          *ngFor="let error of validationUtilService.getUIErrorList(policeDetailsForm.get('FIRNumber'), POLICEDETAILSFORMNAME)">
          {{error.errorMessage || error }}</p>
      </nz-form-explain>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label [nzSpan]="24">FIR Date</nz-form-label>
      <nz-form-control [nzSpan]="24">
        <nz-date-picker formControlName="FIRDate" style="width:100%" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
        <nz-form-explain
        *ngIf="(policeDetailsForm.get('FIRDate').dirty || policeDetailsForm.get('FIRDate').touched) && policeDetailsForm.get('FIRDate').errors">
        <p style="color:red"
          *ngFor="let error of validationUtilService.getUIErrorList(policeDetailsForm.get('FIRDate'), POLICEDETAILSFORMNAME)">
          {{error.errorMessage || error }}</p>
      </nz-form-explain>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label [nzSpan]="24">Address</nz-form-label>
      <nz-form-control [nzSpan]="24">
        <textarea nz-input nzAutosize  formControlName="Address" placeholder="Station's Address"></textarea>
        <nz-form-explain
        *ngIf="(policeDetailsForm.get('Address').dirty || policeDetailsForm.get('Address').touched) && policeDetailsForm.get('Address').errors">
        <p style="color:red"
          *ngFor="let error of validationUtilService.getUIErrorList(policeDetailsForm.get('Address'), POLICEDETAILSFORMNAME)">
          {{error.errorMessage || error }}</p>
      </nz-form-explain>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label [nzSpan]="24">Remarks</nz-form-label>
      <nz-form-control [nzSpan]="24">
        <textarea nz-input nzAutosize formControlName="Remarks" placeholder="Add your remarks here"></textarea>
        <nz-form-explain
        *ngIf="(policeDetailsForm.get('Remarks').dirty || policeDetailsForm.get('Remarks').touched) && policeDetailsForm.get('Remarks').errors">
        <p style="color:red"
          *ngFor="let error of validationUtilService.getUIErrorList(policeDetailsForm.get('Remarks'), POLICEDETAILSFORMNAME)">
          {{error.errorMessage || error }}</p>
      </nz-form-explain>
      </nz-form-control>
    </nz-form-item>
  </div>
</form>